import { render, staticRenderFns } from "./EssayLoading.vue?vue&type=template&id=788bdc4c&scoped=true&"
import script from "./EssayLoading.vue?vue&type=script&lang=ts&"
export * from "./EssayLoading.vue?vue&type=script&lang=ts&"
import style0 from "./EssayLoading.vue?vue&type=style&index=0&id=788bdc4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788bdc4c",
  null
  
)

export default component.exports